// Trava os INPUT e LABELS para obdecer o layout (@ TODOJOGAR EM UM ARQUIVO SEPARADO)

export default class InputLabelPlaceholderEffect {
    start = () => {
        const elements = this.findInputs()
        elements.forEach((e) => {
            this.toggleState(e)
            this.registerListener(e)
        })
    }

    findInputs = () => {
        return document.querySelectorAll('.control input, .control select, .control textarea')
    }

    isFilled = (el) => {
        return el.value !== ''
    }
  
    toggleState = (el) => {
        el.onfocus = () => {
            el.parentElement.classList.add('active')
        }

        el.onblur = () => {
            el.parentElement.classList.remove('active')
        }

        // OVER - O hover é utilizado no input e no label
        el.onmouseover = () => {
            el.parentElement.classList.add('active')
        }

        el.onmouseout = () => {
            el.parentElement.classList.remove('active')
        }

        el.parentElement.onmouseover = () => {
            el.parentElement.classList.add('active')
        }

        el.parentElement.onmouseout = () => {
            el.parentElement.classList.remove('active')
        }
        // END OVER

        if (this.isFilled(el)) {
            el.parentElement.classList.add('filled')
        } else {
            el.parentElement.classList.remove('filled')
        }
    }

    registerListener = (el) => {
        const updateFilledStatus = () => {
            if (this.isFilled(el)) {
                el.parentElement.classList.add('filled');
            } else {
                el.parentElement.classList.remove('filled');
            }
        };

        el.addEventListener('input', updateFilledStatus);
        el.addEventListener('change', updateFilledStatus);
    }
}